import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { FaFacebook, FaInstagram, FaLinkedin, FaYoutube, FaWhatsapp } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import BrandText from '../styles/brandStyles';

export const Footer = () => {
  return (
    <footer className="bg-[#003171] text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* Logo and Social Media */}
          <div className="lg:col-span-2">
            <Logo isWhite={true} />
            <p className="mt-4 text-gray-300 text-sm">
              Soluciones de software para la industria de la construcción desde 1986. 
              Especializados en presupuestos, costos, BIM y gestión de proyectos.
            </p>
            <div className="mt-6 flex space-x-4">
              <a href="https://www.facebook.com/ECOSOFTOPUS" target="_blank" rel="noopener noreferrer" 
                className="text-gray-300 hover:text-[#0066CC]">
                <FaFacebook size={24} />
              </a>
              <a href="https://x.com/OPUSECOSOFT" target="_blank" rel="noopener noreferrer" 
                className="text-gray-300 hover:text-[#0066CC]">
                <FaXTwitter size={24} />
              </a>
              <a href="https://www.instagram.com/opusinfo/" target="_blank" rel="noopener noreferrer" 
                className="text-gray-300 hover:text-[#0066CC]">
                <FaInstagram size={24} />
              </a>
              <a href="https://www.linkedin.com/in/ecosoftopus/" target="_blank" rel="noopener noreferrer" 
                className="text-gray-300 hover:text-[#0066CC]">
                <FaLinkedin size={24} />
              </a>
              <a href="https://www.youtube.com/@OPUSInfo/featured" target="_blank" rel="noopener noreferrer" 
                className="text-gray-300 hover:text-[#0066CC]">
                <FaYoutube size={24} />
              </a>
            </div>
          </div>
          
          {/* Productos */}
          <div>
            <h3 className="text-lg font-semibold mb-4 border-b border-gray-700 pb-2">PRODUCTOS</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/productos/opus" className="text-gray-300 hover:text-[#0066CC]">
                  <BrandText>OPUS</BrandText>
                </Link>
              </li>
              <li>
                <Link to="/inforte" className="text-gray-300 hover:text-[#0066CC]">
                  <BrandText>INFORTE</BrandText>
                </Link>
              </li>
              <li>
                <Link to="/productos/opus-erp" className="text-gray-300 hover:text-[#0066CC]">
                  <BrandText>OPUS ERP</BrandText>
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Soporte */}
          <div>
            <h3 className="text-lg font-semibold mb-4 border-b border-gray-700 pb-2">SOPORTE</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/soporte/descargas" className="text-gray-300 hover:text-[#0066CC]">
                  DESCARGAS
                </Link>
              </li>
              <li>
                <a href="https://wa.me/525579658522" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-[#0066CC] flex items-center">
                  CONTACTO <FaWhatsapp className="ml-1" />
                </a>
              </li>
              <li>
                <Link to="/soporte/faq" className="text-gray-300 hover:text-[#0066CC]">
                  PREGUNTAS FRECUENTES
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Empresa */}
          <div>
            <h3 className="text-lg font-semibold mb-4 border-b border-gray-700 pb-2">EMPRESA</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/en-construccion" className="text-gray-300 hover:text-[#0066CC]">
                  ACERCA DE NOSOTROS
                </Link>
              </li>
              <li>
                <Link to="/en-construccion" className="text-gray-300 hover:text-[#0066CC]">
                  CLIENTES
                </Link>
              </li>
              <li>
                <Link to="/distribuidores" className="text-gray-300 hover:text-[#0066CC]">
                  DISTRIBUIDORES
                </Link>
              </li>
              <li>
                <Link to="/en-construccion" className="text-gray-300 hover:text-[#0066CC]">
                  TRABAJA CON NOSOTROS
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      
      {/* Bottom bar */}
      <div className="bg-[#002552] py-4">
        <div className="container mx-auto px-4 flex flex-col md:flex-row justify-between items-center">
          <div className="text-sm text-gray-400 mb-4 md:mb-0">
            &copy; {new Date().getFullYear()} ECOSOFT S. DE R.L. DE C.V. Todos los derechos reservados.
          </div>
          <div className="flex space-x-6">
            <Link to="/privacidad" className="text-sm text-gray-400 hover:text-[#0066CC]">
              Política de Privacidad
            </Link>
            <Link to="/terminos" className="text-sm text-gray-400 hover:text-[#0066CC]">
              Términos de Uso
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}; 